import React, { useState } from "react";
import {
  CuidaUploadOutline,
  MageFilter,
  MajesticonsTable,
  MaterialSymbolsSearchRounded,
} from "../../assets/icons/LayoutIcon";
import ExportDialogBox from "./ExportDialogBox";
import GridDialogBox from "./GridDialogBox";
import FilterComponent from "./FilterComponent";

const SearchExportComponent = ({
  exportFileName,
  onSearch,
  onExport,
  searchPlaceholder = "Search here..",
  tablefields,
  selectedHeaders,
  onHeadersChange,
  ExportOptionVisisbility = true,
  FilterOptionVisisbility = true,
  fields,
  onApply,
  onReset,
  exportData,
  getComputedExportData,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [openExportDialogBox, setOpenExportDialogBox] = useState(false);
  const [openGridDialogBox, setOpenGridDialogBox] = useState(false);
  const [openFilterDialogBox, setOpenFilterDialogBox] = useState(false);
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    if (onSearch) {
      onSearch(value);
    }
  };

  const handleApply = (item) => {
    console.log("item", item);
    if (onApply) {
      onApply(item);
    }
    console.log(openFilterDialogBox);
    setOpenFilterDialogBox(false);
  };

  return (
    <div className="justify-between block sm:flex  mt-4 sm:space-y-0 space-y-4 items-center ">
      {/* Search Input */}
      <div className="flex justify-between min-h-10  sm:max-h-6  gap-2">
        <div className="flex justify-start items-center border px-2 rounded-md border-gray-300 gap-2">
          <MaterialSymbolsSearchRounded className="text-gray-400 h-5 w-5" />
          <input
            type="text"
            value={searchTerm}
            onChange={handleSearchChange}
            className="w-full rounded pl-2 pr-5 text-sm font-normal text-gray-400 focus:outline-none focus:ring:none"
            placeholder={searchPlaceholder}
          />
        </div>
        {FilterOptionVisisbility && (
          <div className="block sm:hidden items-center border px-2 rounded-md border-gray-300">
            <button onClick={() => setOpenFilterDialogBox(true)}>
              <MageFilter className="text-gray-600 items-center w-6 h-6 mt-1.5 " />
            </button>
          </div>
        )}
      </div>

      {/* Action Icons */}
      <div className="flex justify-between gap-2 items-center">
        {/* Table View Icon */}
        <div
          className="px-2.5 pb-1.5 pt-2 border border-gray-200 rounded-md cursor-pointer items-center"
          onClick={() => {
            setOpenGridDialogBox(true);
          }}
        >
          <MajesticonsTable className="text-gray-700 h-6 w-6 items-center" />
        </div>

        {/* Export Icon */}
        {ExportOptionVisisbility && (
          <div
            className="px-2.5 py-1.5 border border-gray-300 rounded-md flex items-center cursor-pointer"
            onClick={onExport}
          >
            <button
              className="flex items-center"
              onClick={() => {
                setOpenExportDialogBox(true);
              }}
            >
              <CuidaUploadOutline className="text-gray-600 mr-1" />
              <h1 className="text-sm text-gray-600">Export</h1>
            </button>
          </div>
        )}
      </div>

      {openExportDialogBox && (
        <ExportDialogBox
          handleCancel={() => setOpenExportDialogBox(false)}
          fileName={exportFileName}
          data={exportData}
          onExport={onExport}
          getComputedExportData={getComputedExportData}
        />
      )}
      {openGridDialogBox && (
        <GridDialogBox
          handleClose={() => setOpenGridDialogBox(false)}
          selectedHeaders={selectedHeaders}
          tablefields={tablefields}
          onHeadersChange={onHeadersChange}
        />
      )}
      {openFilterDialogBox && (
        <FilterComponent
          fields={fields}
          onApply={handleApply}
          onReset={onReset}
          handleClose={() => {
            setOpenFilterDialogBox(false);
          }}
        />
      )}
    </div>
  );
};

export default SearchExportComponent;
